module.exports = __webpack_public_path__ + "assets/6ff3c1fda16d13e79f9b90a26c2e3849.json";